import { mutate } from "swr";
import { endpointsAssets } from "lib/actions/endpoints/endpointsAssets";
import { authenticatedAxios, fetcher } from "../fetcher";
import { getAssetFromResponse } from "lib/actions/assets/getAssetFromResponse";

export function promoteVersion(id: number, assetId: number) {
  return authenticatedAxios
    .request<void>({
      ...endpointsAssets.versionPromote(id),
    })
    .then((_) => {
      const key = endpointsAssets.asset(assetId);
      return mutate(key, fetcher(key).then(getAssetFromResponse));
    })
    .then((f) => {
      mutate(endpointsAssets.projectAssets(f.projectId));
      mutate(endpointsAssets.asset(assetId));
    });
}
